module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-1267w.ed747433.jpg";